import React from "react";

import { PlanCard } from "QuotePage/Components/PlanCard";
import { StartApplicationButton, MoreDetailsButton } from "QuotePage/Components/PlanCardButtons";
import { connect } from "react-redux";

import { getVisiblePlansRecommendationMode } from "./Selectors";

import type { MedicalPlanPrice } from "Utils/types";

type Props = {
  plans: Array<MedicalPlanPrice>;
};

const recommendationType = (index) => (index === 0 ? "bestValue" : index === 1 ? "moreDoctors" : "lowCopays");

export const RecommendationVisiblePlansDumb = ({ plans }: Props) => (
  <>
    {plans.map((plan, index) => (
      <PlanCard key={`rec_${index}`} planId={plan.id} recommendationType={recommendationType(index)}>
        <MoreDetailsButton planId={plan.id} />
        <StartApplicationButton planId={plan.id} />
      </PlanCard>
    ))}
  </>
);

const mapStateToProps = (state) => ({
  plans: getVisiblePlansRecommendationMode(state),
});

export default connect(mapStateToProps)(RecommendationVisiblePlansDumb);
